// extracted by mini-css-extract-plugin
export default {"wrapper":"SortByFilter_wrapper__vAWFB","active":"SortByFilter_active__rz2bN","text":"SortByFilter_text__3sWVE","filterItem":"SortByFilter_filterItem__v9joy"};